// removed by extract-text-webpack-plugin
module.exports = {"Content":"_2GXOku_Xki77_nBBJ1MpM3","Title":"_256lvjguR_YIG1D7eVifuB","Form":"_2evoiWnXGTr3Ow2YvMobaZ"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/AddClient/AddClient.css
// module id = 349
// module chunks = 0